import React from 'react'
import PropTypes from 'prop-types'
import BenefitRow from '../components/benefitRow'
import BenefitSummary from '../components/benefitSummary'

class BenefitsContainer extends React.Component {

  constructor (props) {
    super (props)
    this.state = {
      benefits: this.props.benefits
    }
  }

  getColor (i) {
    const colors = ["#46cdc0", "#23b1e3", "#ff8351", "#94e864"]
    return colors[i]
  }

  shouldComponentUpdate(nextProps) {
    const filteredBenefitsLength = nextProps.benefits.filter ( (x) => Number(x.number) ).length
    if (filteredBenefitsLength !== this.state.benefits.length -1 ) {
      this.setState ({
        benefits: this.getBenefits(nextProps)
      })
      return false
    }
    return true
  }

  showNext (benefits, i) {
    if ( benefits [i+1] ) {
      const nextBenefit = benefits [i+1]
      benefits[i+1] = {
        ...nextBenefit,
        type: nextBenefit.type,
        number: nextBenefit.number,
        showProgress: true
      }
      benefits[i+1].newTitle && this.props.updateTitle(benefits[i+1].newTitle)
    } else {
      this.props.showContinueDashboard()
      if(gon.employee_layout == 'unum_theme') {
        this.props.updateTitle({
          progressTitle: "Your Confidential Draft LeavePlan is Ready!"
        })
      } else {
        this.props.updateTitle({
          progressTitle: "Your LeavePlan is Ready!"
        })
      }
      this.props.updateTitle({
        progressDescription: "Your customized LeavePlan is complete and \
            includes leave benefits and helpful tasks that you match with based \
            on your unique profile. Continue to your customized Dashboard to begin planning!"
      })
    }

    const currentBenefit = benefits [i]

    benefits[i] = {
      ...currentBenefit,
      type: currentBenefit.type,
      number: currentBenefit.number,
      showProgress: false,
      showRow: true
    }

    this.setState ({
      benefits: benefits
    })
  }

  getBenefitStates (benefit) {
    const state = [
      {
        benefitStates: [
          {
            number: 1,
            state: false,
            label: `We found <number> potentially eligible <benefitLabel> \
                    ${this.props.pluralize("Benefit", benefit.number, "noun")} for you!`
          },
          {
            number: 2,
            state: false,
            label: "LeavePlan Updated with <benefitLabel> Benefits"
          },
          {
            number: 3,
            state: false,
            label: "<benefitLabel> Benefits Matching Complete"
          }
        ],
        speed: 20
      },
      {
        benefitStates: [
          {
            number: 3,
            state: false,
            label: "Tasks Added!"
          }
        ],
        speed: 12
      }
    ]

    return benefit.type === "completed" ? state[1] : state[0]
  }


  getBenefits (props) {
    const notNullBenefits = props.benefits.filter ( (benefit) => {
      return Number (benefit.number)
    })
    const returnBenefits = [...notNullBenefits, ...[{
      type: "completed",
      index: 3,
      newTitle: {
        progressTitle: "Updating your LeavePlan with important tasks...",
        progressDescription: "Your customized LeavePlan has been updated to \
          include all potentially eligible leave benefits. We're now updating your LeavePlan \
          with important tasks to help you navigate your leave."
      }
    }]]

    returnBenefits[0].showProgress = true

    return returnBenefits
  }

  renderBenefitSummary (benefit, i) {
    return benefit.showRow ?
      <BenefitSummary
        benefit={benefit}
        paidLeaveSubstitution={this.props.paidLeaveSubstitution}
        jobProtectedLeaveSubstitution={this.props.jobProtectedLeaveSubstitution}
        index={i}
        key={i}
        pluralize={this.props.pluralize}
      /> : <div className="hidden" key={i}></div>
  }

  renderProgress (benefit, i) {
      return benefit.showProgress ?
        <BenefitRow
          benefits={this.state.benefits}
          benefit={benefit}
          color={this.getColor(benefit.index)}
          key={i}
          id={i}
          showNext={this.showNext.bind(this)}
          benefitStates={this.getBenefitStates(benefit)}
          pluralize={this.props.pluralize}
          paidLeaveSubstitution={this.props.paidLeaveSubstitution}
          jobProtectedLeaveSubstitution={this.props.jobProtectedLeaveSubstitution}
        /> : <div className="hidden" key={i}></div>
  }


  render () {

    if (this.state.benefits.length){
      return (
        <div className="benefits-container">
          {
            this.state.benefits.map (this.renderBenefitSummary.bind(this))
          }
          {
            this.state.benefits.map ( this.renderProgress.bind(this))
          }
        </div>
        )
    }

    return (
      <div className="progress-container">
        <div className="spinner"></div>
      </div>
    )
  }
}

BenefitsContainer.propTypes = {
  benefits: PropTypes.array
}

export default BenefitsContainer;
